import { Text, Box, Image, Link } from '@chakra-ui/react';

export interface ConnectedArticlesProps {
    title: string;
    subtitle: string;
    layout?: '2x1' | '3x1';
    design?: 1 | 2 | 3 | 4;
    articles?: {
        title?: JSX.Element;
        imgUrl: string;
        link: {
            href: string;
            labelText: string;
        };
    }[];
}

const ConnectedArticles: React.FC<ConnectedArticlesProps> = ({
    title,
    subtitle,
    layout,
    design,
    articles,
}) => {
    return (
        <>
            <Box>
                <Text
                    textAlign="center"
                    fontSize="34px"
                    align={'center'}
                    fontWeight={'600'}
                    mb={{ base: '35px', md: '0' }}
                    width={'100%'}
                >
                    {title}
                </Text>
                <Text align={'center'}>{subtitle}</Text>
            </Box>
            <Box
                display={'grid'}
                gridTemplateColumns={{
                    base: 'repeat(1, minmax(0, 1fr))',
                    lg:
                        layout === '2x1'
                            ? 'repeat(2, minmax(0, 1fr))'
                            : 'repeat(3, minmax(0, 1fr))',
                }}
                gap={'30px'}
            >
                {articles?.map(article => {
                    return design === 2 ? (
                        <Box
                            padding={'26px 20px'}
                            border={'3px solid rgba(238, 238, 238, 1)'}
                            display={'flex'}
                            flexDir={'column'}
                        >
                            <Box display={'flex'} gap={'30px'} mb={'auto'}>
                                <Box
                                    display={'flex'}
                                    flexDirection={'column'}
                                    justifyContent={'space-between'}
                                >
                                    <Image maxWidth={'150px'} src={article.imgUrl} />
                                </Box>
                                <Box
                                    display={'flex'}
                                    justifyContent={'space-between'}
                                    flexDir={'column'}
                                >
                                    <Text fontSize={'19px'} mb={'15px'}>
                                        {article.title}
                                    </Text>
                                    <Link
                                        fontWeight={'800'}
                                        href={article.link.href}
                                        display={'flex'}
                                        gap={'5px'}
                                        fontSize={'16px'}
                                        color={'#171717'}
                                        target="_blank"
                                        _hover={{
                                            color: '#171717',
                                            textDecoration: 'none',
                                        }}
                                    >
                                        {article.link.labelText}
                                        <Image
                                            h={'10px'}
                                            w={'10px'}
                                            src="https://www.idosell.com/panel/file-gate.php?id=305802&ext=.png"
                                        />
                                    </Link>
                                </Box>
                            </Box>
                        </Box>
                    ) : (
                        <Box
                            padding={'26px 20px'}
                            border={'3px solid rgba(238, 238, 238, 1)'}
                            display={'flex'}
                            flexDir={'column'}
                        >
                            <Box
                                display={'grid'}
                                gap={'30px'}
                                gridTemplateColumns={'repeat(2, minmax(0, 1fr))'}
                                mb={'auto'}
                            >
                                <Box
                                    display={'flex'}
                                    flexDirection={'column'}
                                    justifyContent={'space-between'}
                                >
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=305756&ext=.png"
                                        alt="Logo IdoSell"
                                        maxWidth={'70px'}
                                        mb={'15px'}
                                    />
                                    <Text mb={'15px'}>{article.title}</Text>
                                </Box>
                                <Box display={'flex'} justifyContent={'center'}>
                                    <Image src={article.imgUrl} />
                                </Box>
                            </Box>
                            <Link
                                fontWeight={'800'}
                                href={article.link.href}
                                display={'flex'}
                                gap={'5px'}
                                target="_blank"
                            >
                                {article.link.labelText}
                                <Image
                                    h={'10px'}
                                    w={'10px'}
                                    src="https://www.idosell.com/panel/file-gate.php?id=305802&ext=.png"
                                />
                            </Link>
                        </Box>
                    );
                })}
            </Box>
        </>
    );
};

export default ConnectedArticles;
